import React from 'react';
import styled from 'styled-components';
import useI18n from 'i18n';

import { OrderStatusDisplay, ORDER_STATUS } from '.';

const HeaderText = styled.h1`
  height: 20%;
  font-size: 2rem;
  font-family: Eina 01;
  margin-bottom: 5%;
`;
const Wrapper = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Text = styled.p`
  height: 10%;
  font-size: 1rem;
  color: #212124;
  font-weight: 600;
  margin-bottom: 5%;
`;

const NumberBox = styled.div`
  height: 30%;
  font-size: 3rem;
  font-weight: 600;
  padding: 12px 16px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
`;

interface Props {
  easyId: string;
  status: ORDER_STATUS;
}

const OrderConfirmation = ({ easyId, status }: Props) => {
  const { i18n } = useI18n();
  return (
    <Wrapper>
      <HeaderText>{i18n('Receipt.HeaderText')}</HeaderText>
      <Text>{i18n('Receipt.OrderNumberText')}</Text>
      <NumberBox>{easyId}</NumberBox>
      <OrderStatusDisplay status={status} />
    </Wrapper>
  );
};

export default OrderConfirmation;
